import React from 'react';
import { SAMPLE, usd } from '../sampleData';

const LEVELS = [
  ['Entry', usd(SAMPLE.entry), 'accent'],
  ['Target', usd(SAMPLE.target), 'up'],
  ['Stop', usd(SAMPLE.stop), 'down'],
  ['Risk : reward', `1 : ${SAMPLE.rr.toFixed(2)}`, ''],
];
const CATALYSTS = ['Quarterly earnings report in 9 trading days', 'Monthly options expiration this Friday', 'Federal Reserve rate decision next week'];
const INVALIDATE = [
  `A daily close below the ${usd(SAMPLE.stop)} stop (1.5x ATR under entry)`,
  'The score falls below 60, which turns the outlook neutral',
  'Relative volume drops under 1.0x while price stalls below the recent high',
];

const Block = ({ title, items, testId }) => (
  <div className="mk-out-block" data-testid={testId}>
    <h3>{title}</h3>
    <ul className="mk-bullets">{items.map((t) => <li key={t}>{t}</li>)}</ul>
  </div>
);

export const OutlookDetails = () => (
  <div className="mk-out-col">
    <div className="mk-cases">
      <div className="mk-case up"><h3>Bull case</h3><p>Price holds above the rising EMA 21 while volume stays above average; a push through the recent high opens room toward the {usd(SAMPLE.target)} target.</p></div>
      <div className="mk-case down"><h3>Bear case</h3><p>Momentum fades from an RSI near {Math.round(SAMPLE.rsi)}, price slips back under the EMA 21 and the {usd(SAMPLE.stop)} stop is tested.</p></div>
    </div>
    <div className="mk-out-block" data-testid="sample-levels">
      <h3>Key levels</h3>
      <dl className="mk-levels">
        {LEVELS.map(([k, v, c]) => <div key={k} className={c}><dt>{k}</dt><dd className="mk-num">{v}</dd></div>)}
      </dl>
    </div>
    <Block title="Upcoming catalysts" items={CATALYSTS} testId="sample-catalysts" />
    <Block title="What would invalidate this view" items={INVALIDATE} testId="sample-invalidation" />
  </div>
);
